export class OperationalDepartamento {

  static path = '/parametricas/';

  id: number;
  nombre: string;
  codigo: string;

  constructor(id: number) {
    this.id = id;
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/operationalDepartamento.model.ts